module.exports = __webpack_public_path__ + "static/media/U2-T1-1-1b_D.746cf3f3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/U2-T1-1-1b_D.svg
// module id = 526
// module chunks = 0